import type { BaseComponentProps } from "@neru/types";
import { deduplicateClass } from "@neru/utils";

export interface CardProps extends BaseComponentProps {
  children: React.ReactNode;
  menu?: React.ReactNode;
  onClick?: () => void;
}

export const Card = ({
  children,
  className,
  "data-testid": testId,
  menu,
  onClick,
}: CardProps) => {
  const containerStyles = `relative w-[stretch] rounded-md bg-primary-0  drop-shadow-base
    ${onClick ? "cursor-pointer hover:drop-shadow-hover" : ""}`;

  const getCardBody = () => {
    if (onClick) {
      return (
        <button
          className={`
            h-full w-full border-0 bg-transparent px-6 py-8 font-inherit
            text-left
          `}
          data-testid={testId}
          onClick={onClick}
          type="button"
        >
          {children}
        </button>
      );
    }

    return (
      <div className="px-6 py-8" data-testid={testId}>
        {children}
      </div>
    );
  };

  return (
    <div
      className={deduplicateClass(containerStyles, className)}
      data-testid={`${testId}-wrapper`}
    >
      {menu ? <div className="absolute right-6 top-8">{menu}</div> : null}
      {getCardBody()}
    </div>
  );
};
